import { ILighterPosition, LighterDeployment } from "../../interfaces/lighter";
import { IAggregatedPosition } from "../../interfaces/positions";
import { convertToAevoAssetName } from "../assetNameMappings";

export const standardizeLighterPositions = (
  positions: ILighterPosition[],
  deployment: LighterDeployment = "robinhood"
): IAggregatedPosition[] => {
  if (!Array.isArray(positions)) {
    return [];
  }

  const standardizedPositions: Record<string, IAggregatedPosition> = {};

  positions.forEach((position) => {
    const size = Number(position.size);
    if (!Number.isFinite(size) || size === 0) {
      return;
    }

    // Convert to Aevo asset name so the Lighter leg aggregates with the same
    // instrument on the other venues (e.g. WTI -> WTIOIL).
    const asset = convertToAevoAssetName(position.symbol, "lighter");
    const instrumentName = `${asset}-PERPETUAL`;
    const sizeAbs = Math.abs(size);
    const markPrice = position.markPrice
      ? Number(position.markPrice)
      : Number(position.positionValue) / sizeAbs;

    if (!standardizedPositions[instrumentName]) {
      standardizedPositions[instrumentName] = {
        instrument_name: instrumentName,
        isPerpetual: true,
        asset,
        delta: 0,
        gamma: 0,
        vega: 0,
        theta: 0,
        contracts: 0,
        pnl: 0,
        side: "-",
        source: deployment === "mainnet" ? "Lighter Mainnet" : "Lighter Robinhood",
        lighterDelta: 0,
        lighterMarkPrice: 0,
      };
    }

    const standardized = standardizedPositions[instrumentName];
    standardized.delta += size;
    standardized.contracts += size;
    standardized.pnl += Number(position.unrealizedPnl || 0);
    standardized.side = standardized.contracts > 0 ? "buy" : "sell";
    const deltaKey = deployment === "mainnet" ? "lighterMainnetDelta" : "lighterDelta";
    const markKey = deployment === "mainnet" ? "lighterMainnetMarkPrice" : "lighterMarkPrice";
    standardized[deltaKey] = (standardized[deltaKey] || 0) + size;
    if (Number.isFinite(markPrice) && markPrice > 0) {
      standardized[markKey] = markPrice;
    }
  });

  return Object.values(standardizedPositions);
};
